<template>
  <v-flex xs12 md12 class="mt-2 mb-0 pb-0">
    <div class="mx-3 mt-5">
      <v-tabs
        class="rounded light-shadow"
        center-active
        show-arrows
        v-model="tabsSearch"
      >
        <v-tab v-show="tarrifplanHasAbility('parts_and_repairtimes')" id="searchRepairtimesTab">
          <v-icon small left>$works</v-icon>
          {{ $t("viewSearch.repairtimes") }}
        </v-tab>
        <v-tab>
          <v-icon small left>$partcode</v-icon>
          {{ $t("viewSearch.by_part_numebr") }}
        </v-tab>
        <template v-if="tarrifplanHasAbility('can_use_catalogs')">
          <v-tab>
            <v-icon small left>$oem</v-icon>
            {{ $t("viewSearch.by_oem_catalog") }}
          </v-tab>
          <template v-for="cp in tabsCatalogParts">
            <v-tab>
              <v-icon small left>{{ cp.icon || "" }}</v-icon>
              {{ $t("viewSearch.catalogPartsTitles." + cp.title) }}
            </v-tab>
          </template>
        </template>
      </v-tabs>
    </div>
    <div v-show="tabsSearch === 0 || tabsSearch === 1">
      <v-layout>
        <v-row class="mx-0 w-100">
          <v-col md="6" xs="12">
            <h1 class="py-3 text-no-wrap" v-if="tabsSearch === 0">
              {{ $t("viewSuppliersSearch.title_repairtimes") }}
            </h1>
            <h1 class="py-3 text-no-wrap" v-if="tabsSearch === 1">
              {{ $t("viewSuppliersSearch.title") }}
            </h1>
            <!-- блок поиска Repairtimes -->
            <v-col
              v-if="tabsSearch === 0"
              class="mt-2 pt-0 pb-0 mb-0 px-0 mx-0"
            >
              <repairtime-tree
                :height="repairTimesTreeWrapHeight"
              ></repairtime-tree>
            </v-col>
            <!-- блок поиска Suppliers -->
            <v-col v-if="tabsSearch === 1" class="mt-2 pt-0 px-0 mx-0">
              <search-suppliers :data-for-search="dataForSearch"/>
            </v-col>
          </v-col>
          <v-col md="6" xs="12">
            <multi-cart :is-visible="tabsSearch === 0 || tabsSearch === 1" :watcher-for-resize="tabsSearch === 0 || tabsSearch === 1"></multi-cart>
          </v-col>
        </v-row>
      </v-layout>
    </div>
    <div v-show="tabsSearch === 2">
      <v-layout row wrap px-3 pt-0>
        <v-col col="12" fill-height md="12" xl="12" class="py-0">
          <h1 class="w-100 py-6">{{ $t("viewOEMParts.title") }}</h1>
          <iframe id="displayframeOEM" class="displayframe" ref="OEMiframe" @load="iframeLoaded"></iframe>
        </v-col>
      </v-layout>
    </div>
    <template v-for="cp in tabsCatalogParts">
      <div v-if="tabsSearch === cp.tabsSearch">
        <v-layout row wrap px-3 pt-0>
          <v-col col="12" fill-height md="12" xl="12">
            <iframe
              @load="iframeLoaded"
              data-type="catalog-parts"
              class="displayframe displayframeCP"
              :src="$apiURL + '/сatalogparts/' + cp.title"
            >
            </iframe>
          </v-col>
        </v-layout>
      </div>
    </template>

  </v-flex>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import RepairtimeTree from "@/components/repairtime/RepairtimeTree";
import MultiCart from "@/components/common/MultiCart";
import CommonMixin from "@/mixins/common";
import ApplicabilityWindow from "@/components/common/ApplicabilityWindow";
import RightsMixin from "@/mixins/rights";
import SearchSuppliers from "@/components/search/SearchSuppliers";

export default {
  components: {
    SearchSuppliers,
    ApplicabilityWindow,
    MultiCart,
    RepairtimeTree,
  },
  mixins: [CommonMixin, RightsMixin],
  data: () => ({
    currentWidgetHash: null,
    repairTimesTreeWrapHeight: null,
    tabsSearch: 0,
    tmpPartForAddToCart: null,
    tmpRepairtimeId: null,
    tableBrandsGet: [],

    dataForSearch: {
      brand: null,
      part_code: null,
    },
    tabsCatalogParts: [
      {
        tabsSearch: 3,
        title: "pc",
        icon: "$aftermarket",
      },
      {
        tabsSearch: 4,
        title: "to",
        icon: "$catalog_maintenance",
      },

      {
        tabsSearch: 5,
        title: "accessories",
        icon: "$accessories",
      },

      {
        tabsSearch: 6,
        title: "batteries",
        icon: "$batteries",
      },
      {
        tabsSearch: 7,
        title: "oils",
        icon: "$oils",
      },
      {
        tabsSearch: 8,
        title: "lamps",
        icon: "$lamps",
      },
      {
        tabsSearch: 9,
        title: "bolts",
        icon: "$bolts",
      },
      {
        tabsSearch: 10,
        title: "wheels",
        icon: "$wheels",
      },
      {
        tabsSearch: 11,
        title: "tires",
        icon: "$tires",
      },
      {
        tabsSearch: 12,
        title: "caps",
        icon: "$caps",
      },
    ],

  }),
  mounted: function () {
    if(this.isFullTree){
      this.$store.dispatch('repairtimes/get');
    }
    // Listen to message from iframe element
    if(this.hasListenerMessagesFromIframe!==true) {
      window.addEventListener("message", (msg) => {
        try {
          let item = {car: null};
          let add = false;
          if (msg.data.type === "part") {
            item.part = {
              brand: msg.data.part.root_brand,
              part_code: msg.data.part.search_number,
              name: msg.data.part.part_name,
            };
            this.widgetHash = msg.data.hash;
            add = true;
          }
          if (msg.data.type === "catalogparts") {
            item.part = {
              name: msg.data.part.part.name,
              brand: msg.data.part.part.brand,
              part_code: msg.data.part.part.number,
            };
            add = true;
          }

          if (add) this.addDummyToCart(item);
        } catch (e) {
          console.log(e);
        }
      });
      this.hasListenerMessagesFromIframe=true;
    }
    for (let i in this.tabsCatalogParts) {
      if (this.tabsCatalogParts[i].title === this.$route.params.search_page) {
        this.tabsSearch = this.tabsCatalogParts[i].tabsSearch;
      }
    }
    if (
      this.$route.params.search_page === "oem" &&
      !this.$route.params.search_number
    ) {
      this.tabsSearch = 2;
    }
    if (
      this.$route.fullPath === "/search/search" ||
      this.$route.fullPath === "/search/search/" ||
        this.$route.params.search_page === 'search'
    ) {
      this.tabsSearch = 1;
    }
    this.$nextTick(function () {
      this.getRepairTimesTreeWrapHeight();
    });

  },
  computed: {
    ...mapFields("cart", ["carts", "defaultCartId", "savingInProgress"]),
    ...mapFields("common", ["widgetHash", "hasListenerMessagesFromIframe"]),
    ...mapFields("repairtimes", ["repairtimes", "isFullTree"]),
    ...mapFields("suppliers", ["time", "brands", "parts", "suppliersNames"]),
    OEMwidgetURL() {
      return process.env.VUE_APP_WIDGET_URL_PAGE + this.widgetHash;
    },
  },
  watch: {
    OEMwidgetURL() {
      let rnd = Math.random().toString(36).substring(2, 15);
      let link =
        process.env.VUE_APP_WIDGET_URL_PAGE + this.widgetHash + "?rnd=" + rnd;
      this.$refs.OEMiframe.contentWindow.location.replace(link);
    },
    $route(to, fr) {
      if (this.$route.params.search_page && this.$route.params.search_number) {
        this.tabsSearch = 1;
        this.dataForSearch.part_code = this.$route.params.search_number;
        this.dataForSearch.brand = this.$route.params.search_page;
      }
      if (
        this.$route.params.search_page === "oem" &&
        !this.$route.params.search_number
      ) {
        this.tabsSearch = 2;
      }

      if( ! this.$route.params.brand && ! this.$route.params.search_number &&
          ! this.$route.params.search_page){
        this.tabsSearch = 0;
      }
    },
    tabsSearch(to) {
      if (to === 0 && (this.$route.fullPath !== "/search/" && this.$route.fullPath !== "/search")) {
        this.$router.push({ name: 'search', params:{}})
        document.body.style.overflow = "hidden";
        return;
      }
      if (to === 1) {
        document.body.style.overflow = "auto";
        if (this.$route.params.search_page !== "search") {
          this.$router.push({ name: 'search', params: { search_page:"search" } })
        }
        return;
      }

      if (to === 2) {
        if (this.currentWidgetHash != this.widgetHash) {
          let rnd = Math.random().toString(36).substring(2, 15);
          let link =
            process.env.VUE_APP_WIDGET_URL_PAGE +
            "?rnd=" +
            rnd +
            this.widgetHash;
          this.$refs.OEMiframe.contentWindow.location.replace(link);
          this.currentWidgetHash = this.widgetHash;
        }
      }
      if (to === 2 && this.$route.params.search_page!=='oem') {
        this.$router.push({ name: 'search', params: { search_page:"oem" } })
        document.body.style.overflow = "hidden";
      }
      for (let i in this.tabsCatalogParts) {
        if (
          to === this.tabsCatalogParts[i].tabsSearch &&
          this.$route.params.search_page !== this.tabsCatalogParts[i].title
        ) {
          this.$router.push({ name: 'search', params: { search_page: this.tabsCatalogParts[i].title} })
          document.body.style.overflow = "hidden";
        }
      }
    },

  },
  methods: {
    iframeLoaded(){
        let elements = document.querySelectorAll(".displayframeCP");
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.height =
                document.body.clientHeight - elements[i].offsetTop - 95 + "px";
        }
        //displayframeOEM
        let oemFrame = document.getElementById('displayframeOEM');
        if(oemFrame){
          oemFrame.style.height =
              window.innerHeight - 235 + "px";
        }
    },
    getRepairTimesTreeWrapHeight() {
      this.repairTimesTreeWrapHeight = window.innerHeight - 360;
    },
    supplierNameForHuman(name) {
      return this.suppliersNames[name] || name;
    },
  },
};
</script>

<style>
.w-100 {
  width: 100%;
}

.displayframe {
  border: none;
  background: #fff;
  width: 100%;
  height: 67%;
}
</style>
